<template>
  <div v-if="!isOpen" itemscope=""
       class="faq-block page_speed_321225376 service-block">
    <details class="faq-block__item" itemscope=""
             v-for="category in data">
      <summary class="faq-block__question" itemprop="name">
        <span>{{category.name}}</span>
        <div class="open-close-block"><i
            class="icon-open-close-block"></i>
        </div>
      </summary>
      <div itemscope=""
          >
        <div class="faq-block__answer text-section " itemprop="text">
          <table>
            <thead>
            <tr>
              <th>{{Lang.get('common.analiz_name')}}</th>
              <th>{{Lang.get('common.analiz_price')}}</th>
              <th>{{Lang.get('common.analiz_time')}}</th>
              <th>{{Lang.get('common.analiz_code')}}</th>
              <th>{{Lang.get('common.analiz_order')}}</th>
            </tr>
            </thead>
            
            <tbody>
            <tr v-if="category.services" v-for="service in category.services">
              <td>
                <a :href="service.alias.url ? '/' + service.alias.url : '#'">{{service.name.replace(/\&nbsp;/g, '')}}</a>
              </td>
              <td>{{service.price}}
              </td>
              <td>{{service.lead_time ? service.lead_time : '-' }}</td>
              <td>{{service.code}}</td>
              <td @click="goToCart(service.code)"
                  style="cursor: pointer">
                <span class="my-button" v-html="getPriceWithDiscount(service.price) + ' грн.'"></span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </details>
  </div>
</template>

<script>
  export default {
      name: 'services-block',
      data() {
          return {
              Lang,
              defaultLanguage,
              data: {},
              isOpen: false,
          }
      },
      watch: {
          filters: {
              handler: _.debounce(
                  function () {
                      this.updateData();
                  }, 500
              ),
              deep: true
          },
      },
      methods: {
          getPriceWithDiscount(initPrice) {
              initPrice = Math.round(parseFloat(initPrice * (100 - 5))) / 100;
              return initPrice;
          },
          goToCart(code) {
              let url = 'http://artmediuz.medcloud.pro/?tests=' + code + '&tab=cart';
              window.open(url, '_blank');
          },
          updateData() {
              this.loading = true;
              let prefix = Lang.locale === this.defaultLanguage ? '' : '/' + Lang.locale;
              axios.post(prefix + '/services/search').then(res => {
                  this.data = res.data.result;
                  this.isOpen = false;
              }).catch(err => this.loading = false);

          },
      },
      mounted() {
          this.updateData();
      }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/service/ServicesBlock.vue